/* This file was generated automatically. Do not edit manually. */

export enum ReservationContractExternalTemplateFieldType {
    Checkbox = 'Checkbox',
    Date = 'Date',
    Email = 'Email',
    Note = 'Note',
    Numerical = 'Numerical',
    Text = 'Text',
    Number = 'Number',
    Radio = 'Radio',
}
